(function () {
  const root = document.querySelector("[data-qpay-checkout]");

  if (!root) {
    return;
  }

  document.documentElement.classList.add("qpay-checkout-page");
  document.body.classList.add("qpay-checkout-page");

  const config = JSON.parse(root.querySelector("[data-qpay-config]").textContent);
  const form = root.querySelector("[data-qpay-form]");
  const submitButton = root.querySelector("[data-qpay-submit]");
  const statusBox = root.querySelector("[data-qpay-status]");
  const modal = document.querySelector("[data-qpay-modal]");
  const qrBox = document.querySelector("[data-qpay-qr]");
  const bankTransferBox = document.querySelector("[data-qpay-bank-transfer]");
  const checkButton = root.querySelector("[data-qpay-check]");
  const openModalButton = root.querySelector("[data-qpay-open-modal]");
  const bankBox = document.querySelector("[data-qpay-banks]");
  const bankList = document.querySelector("[data-qpay-bank-list]");
  const modalTitle = document.querySelector("[data-qpay-modal-title]");
  const modalAmount = document.querySelector("[data-qpay-modal-amount]");
  const successBox = document.querySelector("[data-qpay-success]");
  const successCloseButton = document.querySelector("[data-qpay-success-close]");
  const modalCheckButton = document.querySelector("[data-qpay-modal-check]");
  const copyBankAccountButton = document.querySelector("[data-copy-bank-account]");
  const shippingOptionsBox = root.querySelector("[data-shipping-options]");
  const shippingTitleInput = root.querySelector("[data-shipping-title-input]");
  const shippingPriceInput = root.querySelector("[data-shipping-price-input]");
  const summaryShipping = root.querySelector("[data-summary-shipping]");
  const summaryTotal = root.querySelector("[data-summary-total]");
  const countrySelect = form.querySelector('[name="country_code"]');
  const cityInput = form.querySelector('[name="city"]');
  const addressInput = form.querySelector('[name="detailed_address"]');
  const closeButtons = document.querySelectorAll("[data-qpay-close]");
  const paymentMethodInputs = root.querySelectorAll('input[name="payment_method"]');
  const paymentPanels = root.querySelectorAll("[data-payment-panel]");
  const policyModal = document.querySelector("[data-policy-modal]");
  const policyTitle = document.querySelector("[data-policy-title]");
  const policyBody = document.querySelector("[data-policy-body]");
  const policyCloseButtons = document.querySelectorAll("[data-policy-close]");
  const policyTriggers = root.querySelectorAll("[data-policy-trigger]");
  const FREE_SHIPPING_THRESHOLD = Number(config.freeShippingThreshold || 0);
  const STANDARD_SHIPPING_PRICE = Number(config.standardShippingPrice || 0);
  const PICKUP_SHIPPING_TITLE = config.pickupShippingTitle || "Дэлгүүр дээрээс очиж авах";
  let activeSessionKey = null;
  let shippingRefreshTimer = null;
  let cartPreparedFromQuery = false;
  let shippingRatesLoading = false;

  function setCheckoutSubmitLabel() {
    if (submitButton) {
      submitButton.textContent = getSelectedPaymentMethod() === "cod" ? "Захиалга баталгаажуулах" : "Төлбөр төлөх";
    }
  }

  function isMobileDevice() {
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || "");
  }

  function getSelectedPaymentMethod() {
    const selected = root.querySelector('input[name="payment_method"]:checked');
    return selected ? selected.value : "qpay";
  }

  function updateSubmitButtonState() {
    if (!submitButton) {
      return;
    }

    if (shippingRatesLoading) {
      submitButton.disabled = true;
      submitButton.textContent = "Хүргэлтийн үнэ шалгаж байна...";
      return;
    }

    if (submitButton.textContent === "Хүргэлтийн үнэ шалгаж байна...") {
      submitButton.disabled = false;
      setCheckoutSubmitLabel();
    }
  }

  function syncPaymentPanels() {
    const selectedMethod = getSelectedPaymentMethod();

    paymentPanels.forEach(function (panel) {
      panel.hidden = panel.getAttribute("data-payment-panel") !== selectedMethod;
    });

    setCheckoutSubmitLabel();

    updateSubmitButtonState();

    if (checkButton) {
      checkButton.hidden = selectedMethod !== "qpay" || !activeSessionKey;
    }

    if (openModalButton) {
      openModalButton.hidden = selectedMethod !== "qpay" || !activeSessionKey;
    }
  }

  function openModal() {
    if (modal) {
      modal.hidden = false;
      document.body.style.overflow = "hidden";
    }
  }

  function closeModal() {
    if (modal) {
      modal.hidden = true;
      document.body.style.overflow = "";
    }
  }

  closeButtons.forEach(function (button) {
    button.addEventListener("click", closeModal);
  });

  if (successCloseButton) {
    successCloseButton.addEventListener("click", closeModal);
  }

  function openPolicyModal(policyKey) {
    const template = document.querySelector(`[data-policy-template="${policyKey}"]`);

    if (!policyModal || !policyTitle || !policyBody || !template) {
      return;
    }

    policyTitle.textContent = template.getAttribute("data-policy-title") || "";
    policyBody.innerHTML = template.innerHTML.trim();
    policyModal.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closePolicyModal() {
    if (!policyModal) {
      return;
    }

    policyModal.hidden = true;
    if (!modal || modal.hidden) {
      document.body.style.overflow = "";
    }
  }

  policyTriggers.forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      openPolicyModal(trigger.getAttribute("data-policy-trigger"));
    });
  });

  policyCloseButtons.forEach(function (button) {
    button.addEventListener("click", closePolicyModal);
  });

  if (copyBankAccountButton) {
    copyBankAccountButton.addEventListener("click", async function () {
      try {
        await navigator.clipboard.writeText(config.iban || config.accountNumber || "");
        copyBankAccountButton.textContent = "Данс хуулсан";
      } catch (_error) {
        copyBankAccountButton.textContent = "Хуулах боломжгүй";
      }
    });
  }

  function normalizeBankLinks(invoice) {
    const urls = Array.isArray(invoice.urls) ? invoice.urls : [];

    return urls
        .map(function (entry, index) {
          const label =
              entry.name || entry.description || entry.bank || entry.app_name || `Сувaг ${index + 1}`;
          const url =
              entry.link || entry.url || entry.web_url || entry.qpay_url || entry.deeplink || "";
          const deepLink =
              entry.deeplink || entry.deep_link || entry.app_link || entry.link || "";
          const logo =
              entry.logo || entry.logo_url || entry.icon || entry.icon_url || entry.image || "";

          if (!url && !deepLink) {
            return null;
          }

          return { label: label, url: url || deepLink, deepLink: deepLink || url, logo: logo };
        })
        .filter(Boolean);
  }

  function buildBankFallback(label) {
    return label
        .split(" ")
        .slice(0, 2)
        .map(function (part) {
          return part.charAt(0);
        })
        .join("")
        .slice(0, 3);
  }

  function normalizeQrImageSource(value) {
    if (!value) {
      return "";
    }

    if (value.startsWith("data:image")) {
      return value;
    }

    if (value.startsWith("http://") || value.startsWith("https://")) {
      return value;
    }

    return `data:image/png;base64,${value}`;
  }

  function setStatus(message, tone) {
    if (!statusBox) {
      console.warn("[qpay-checkout] status box not found", { message, tone });
      return;
    }

    statusBox.hidden = false;
    statusBox.textContent = message;
    statusBox.style.background = tone === "error" ? "#fff1f2" : "#eef4ff";
    statusBox.style.color = tone === "error" ? "#9f1239" : "#17357b";
  }

  function resetModal() {
    if (modalTitle) {
      modalTitle.textContent = "Төлбөр төлөх";
    }

    if (modalAmount) {
      modalAmount.hidden = true;
      modalAmount.textContent = "";
    }

    if (successBox) {
      successBox.hidden = true;
    }

    if (bankTransferBox) {
      bankTransferBox.hidden = true;
    }

    if (modalCheckButton) {
      modalCheckButton.hidden = true;
      modalCheckButton.disabled = false;
      modalCheckButton.textContent = "Төлбөр шалгах";
    }

    if (qrBox) {
      qrBox.hidden = true;
      qrBox.innerHTML = "";
    }

    if (bankBox && bankList) {
      bankBox.hidden = true;
      bankList.innerHTML = "";
    }

    if (copyBankAccountButton) {
      copyBankAccountButton.textContent = "Данс хуулах";
    }
  }

  function renderSuccessModal() {
    resetModal();

    if (modalTitle) {
      modalTitle.textContent = "Амжилттай";
    }

    if (successBox) {
      successBox.hidden = false;
    }

    openModal();
  }

  function renderBankTransferModal(amount, currency) {
    resetModal();

    if (modalTitle) {
      modalTitle.textContent = "Дансаар төлөх";
    }

    if (modalAmount) {
      modalAmount.hidden = false;
      modalAmount.textContent = formatMoney(amount, currency);
    }

    if (bankTransferBox) {
      bankTransferBox.hidden = false;
    }

    openModal();
  }

  function renderQPayModal(invoice, amount, currency) {
    resetModal();

    if (modalTitle) {
      modalTitle.textContent = "QPay QR";
    }

    if (modalAmount) {
      modalAmount.hidden = false;
      modalAmount.textContent = formatMoney(amount, currency);
    }

    const qrImage = normalizeQrImageSource(
        invoice.qr_image || invoice.qrImage || invoice.qPay_QR_image || invoice.qrText || ""
    );
    const paymentLink = invoice.invoice_url || invoice.invoiceUrl || invoice.url || "";
    const bankLinks = normalizeBankLinks(invoice);

    if (qrBox) {
      qrBox.hidden = false;
      qrBox.innerHTML = "";

      if (qrImage) {
        const image = document.createElement("img");
        image.src = qrImage;
        image.alt = "QPay QR";
        qrBox.appendChild(image);
      }

      if (paymentLink) {
        const link = document.createElement("a");
        link.href = paymentLink;
        link.target = "_blank";
        link.rel = "noreferrer";
        link.textContent = "QPay линк нээх";
        link.className = "qpay-checkout__button";
        link.style.display = "inline-block";
        link.style.marginTop = "12px";
        qrBox.appendChild(link);
      }
    }

    if (bankBox && bankList) {
      bankList.innerHTML = "";

      if (bankLinks.length > 0) {
        bankBox.hidden = false;

        bankLinks.forEach(function (entry) {
          const link = document.createElement("a");
          link.href = isMobileDevice() ? entry.deepLink || entry.url : entry.url || entry.deepLink;
          link.target = "_blank";
          link.rel = "noreferrer";
          link.className = "qpay-modal__bank-link";

          if (entry.logo) {
            const image = document.createElement("img");
            image.src = entry.logo;
            image.alt = entry.label;
            image.className = "qpay-modal__bank-logo";
            link.appendChild(image);
          } else {
            const fallback = document.createElement("div");
            fallback.className = "qpay-modal__bank-fallback";
            fallback.textContent = buildBankFallback(entry.label);
            link.appendChild(fallback);
          }

          const text = document.createElement("div");
          text.className = "qpay-modal__bank-name";
          text.textContent = entry.label;
          link.appendChild(text);

          bankList.appendChild(link);
        });
      }
    }

    if (modalCheckButton) {
      modalCheckButton.hidden = false;
    }

    openModal();
  }

  paymentMethodInputs.forEach(function (input) {
    input.addEventListener("change", syncPaymentPanels);
  });

  syncPaymentPanels();
  updateSummaryAmounts();

  if (countrySelect) {
    countrySelect.addEventListener("change", scheduleShippingRefresh);
  }

  if (cityInput) {
    cityInput.addEventListener("input", scheduleShippingRefresh);
  }

  if (addressInput) {
    addressInput.addEventListener("input", scheduleShippingRefresh);
  }

  renderShippingRates([]);

  async function prepareCartFromQuery() {
    if (cartPreparedFromQuery) {
      return;
    }

    const url = new URL(window.location.href);
    const variantId = url.searchParams.get("add");
    const quantity = Number(url.searchParams.get("qty") || "1");

    if (!variantId) {
      return;
    }

    cartPreparedFromQuery = true;
    submitButton.disabled = true;
    submitButton.textContent = "Бараа бэлдэж байна...";

    try {
      const response = await fetch(getLocaleAwareUrl("/cart/add.js"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1
            }
          ]
        })
      });

      if (!response.ok) {
        let message = "Cart add failed";

        try {
          const errorPayload = await response.json();
          message = errorPayload.description || errorPayload.message || message;
        } catch (_jsonError) {
          message = await response.text();
        }

        throw new Error(message);
      }

      url.searchParams.delete("add");
      url.searchParams.delete("qty");
      const nextUrl = url.pathname + (url.search ? url.search : "");
      window.history.replaceState({}, "", nextUrl);
      window.location.reload();
    } catch (error) {
      submitButton.disabled = false;
      setCheckoutSubmitLabel();
      setStatus("Барааг QPay checkout руу бэлдэх үед алдаа гарлаа. " + (error.message || ""), "error");
    }
  }

  prepareCartFromQuery();

  function formatMoney(amount, currency) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "MNT",
      maximumFractionDigits: 2
    }).format(amount || 0);
  }

  function getLocaleAwareUrl(path) {
    const rootPath =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : "/";

    return rootPath + path.replace(/^\//, "");
  }

  function getCountryName() {
    if (!countrySelect) {
      return "Mongolia";
    }

    const selectedOption = countrySelect.options[countrySelect.selectedIndex];
    return selectedOption ? selectedOption.text : "Mongolia";
  }

  function getSelectedShippingPrice() {
    return Number(shippingPriceInput && shippingPriceInput.value ? shippingPriceInput.value : 0);
  }

  function getCartSubtotal() {
    return Number(config.cartSubtotal || 0);
  }

  function getDeliveryShippingRate() {
    const subtotal = getCartSubtotal();
    const isFree = subtotal >= FREE_SHIPPING_THRESHOLD;

    return {
      title: config.defaultShippingTitle || "Хүргэлт",
      price: isFree ? 0 : STANDARD_SHIPPING_PRICE,
      currency: config.currency || "MNT",
      description: ""
    };
  }

  function getPickupShippingRate() {
    return {
      title: PICKUP_SHIPPING_TITLE,
      price: 0,
      currency: config.currency || "MNT",
      description: "Захиалгаа дэлгүүр дээрээс өөрөө авна"
    };
  }

  function isPickupShippingTitle(title) {
    return String(title || "") === PICKUP_SHIPPING_TITLE;
  }

  function buildPickupEmail(phone) {
    const normalizedPhone = String(phone || "").replace(/\D/g, "") || Date.now().toString();
    return `pickup+${normalizedPhone}@gerhub.local`;
  }

  function setPickupFieldState(input, isPickup) {
    if (!input) {
      return;
    }

    if (!input.dataset.qpayInitiallyRequired) {
      input.dataset.qpayInitiallyRequired = input.required ? "true" : "false";
    }

    input.required = !isPickup && input.dataset.qpayInitiallyRequired === "true";

    if (input.name !== "phone") {
      input.disabled = isPickup;
    }

    const wrapper = input.closest(".qpay-checkout__checkbox-row") || input;
    wrapper.hidden = isPickup;
  }

  function syncPickupAddressRequirements(rate) {
    const isPickup = rate && isPickupShippingTitle(rate.title);
    const contactSection = form.querySelector('[name="email"]')?.closest(".qpay-checkout__section");
    const addressSection = addressInput?.closest(".qpay-checkout__section");
    const addressTitle = addressSection?.querySelector(".qpay-checkout__title");

    if (contactSection) {
      contactSection.hidden = isPickup;
    }

    if (addressTitle) {
      if (!addressTitle.dataset.defaultText) {
        addressTitle.dataset.defaultText = addressTitle.textContent || "";
      }

      addressTitle.textContent = isPickup ? "Холбоо барих утас" : addressTitle.dataset.defaultText;
    }

    [
      form.querySelector('[name="email"]'),
      form.querySelector('[name="first_name"]'),
      form.querySelector('[name="last_name"]'),
      form.querySelector('[name="detailed_address"]'),
      form.querySelector('[name="entrance_code"]'),
      form.querySelector('[name="city"]'),
      form.querySelector('[name="additional_phone"]'),
      form.querySelector('[name="country_code"]'),
    ].forEach(function (input) {
      setPickupFieldState(input, isPickup);
    });

    form.querySelectorAll(".qpay-checkout__checkbox-row").forEach(function (row) {
      row.hidden = isPickup;
    });

    const phoneInput = form.querySelector('[name="phone"]');

    if (phoneInput) {
      phoneInput.required = true;
      phoneInput.disabled = false;
      phoneInput.hidden = false;
    }
  }

  function updateSummaryAmounts() {
    const shippingPrice = getSelectedShippingPrice();
    const subtotal = getCartSubtotal();
    const currency = config.currency || "MNT";
    const total = subtotal + shippingPrice;

    if (summaryShipping) {
      summaryShipping.textContent = formatMoney(shippingPrice, currency);
    }

    if (summaryTotal) {
      summaryTotal.textContent = formatMoney(total, currency);
    }
  }

  function selectShippingRate(rate, options) {
    if (shippingTitleInput) {
      shippingTitleInput.value = rate.title;
    }

    if (shippingPriceInput) {
      shippingPriceInput.value = String(rate.price);
    }

    syncPickupAddressRequirements(rate);

    Array.from(options || []).forEach(function (option) {
      option.classList.toggle("qpay-checkout__shipping-option--active", option.dataset.rateTitle === rate.title);
      const radio = option.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = option.dataset.rateTitle === rate.title;
      }
    });

    updateSummaryAmounts();
  }

  function renderShippingRates(rates) {
    if (!shippingOptionsBox) {
      return;
    }

    const normalizedRates = [getDeliveryShippingRate(), {
      title: "Шуурхай хүргэлт",
      price: 20000,
      currency: config.currency || "MNT",
      description: "Ажлын 3 цагт"
    }];

    shippingOptionsBox.innerHTML = "";

    normalizedRates.forEach(function (rate, index) {
      const wrapper = document.createElement("div");
      wrapper.className = "qpay-checkout__shipping-option";
      wrapper.dataset.rateTitle = rate.title;

      const id = "shipping-rate-" + index;
      const input = document.createElement("input");
      input.type = "radio";
      input.name = "shipping_option_choice";
      input.id = id;
      input.value = rate.title;

      const label = document.createElement("label");
      label.htmlFor = id;
      const ratePrice = Number(rate.price || 0);
      const priceLabel = ratePrice > 0
          ? formatMoney(ratePrice, rate.currency || config.currency || "MNT")
          : "А, Б бүс";
      label.innerHTML =
          '<span class="qpay-checkout__shipping-copy">' +
          `<strong>${ratePrice > 0 ? rate.title : "Хүргэлт үнэгүй"}</strong>` +
          (rate.description ? `<small>${rate.description}</small>` : "") +
          "</span>" +
          '<span class="qpay-checkout__shipping-price">' +
          priceLabel +
          "</span>";

      input.addEventListener("change", function () {
        selectShippingRate(rate, shippingOptionsBox.children);
      });

      wrapper.appendChild(input);
      wrapper.appendChild(label);
      shippingOptionsBox.appendChild(wrapper);
    });

    const defaultRate =
        normalizedRates.find(function (rate) {
          return shippingTitleInput && rate.title === shippingTitleInput.value;
        }) || normalizedRates[0];

    selectShippingRate(defaultRate, shippingOptionsBox.children);
  }

  async function fetchDynamicShippingRates() {
    if (!shippingOptionsBox) {
      return;
    }

    renderShippingRates([]);
    shippingRatesLoading = false;
    updateSubmitButtonState();
  }

  function scheduleShippingRefresh() {
    if (shippingRefreshTimer) {
      window.clearTimeout(shippingRefreshTimer);
    }

    shippingRefreshTimer = window.setTimeout(function () {
      fetchDynamicShippingRates().catch(function () {
        renderShippingRates([]);
      });
    }, 350);
  }

  async function getCart() {
    const response = await fetch("/cart.js");
    return response.json();
  }

  async function clearCart() {
    const response = await fetch(getLocaleAwareUrl("/cart/clear.js"), {
      method: "POST",
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Cart clear failed");
    }
  }

  function normalizeItemProperties(item) {
    const properties = item && item.properties && typeof item.properties === "object"
      ? item.properties
      : {};

    return Object.entries(properties).reduce(function (result, entry) {
      const key = entry[0];
      const value = entry[1];

      if (value === null || value === undefined || value === "") {
        return result;
      }

      result[key] = String(value);
      return result;
    }, {});
  }

  function normalizeCartItems(cart) {
    return (cart.items || []).map((item) => ({
      variantId: "gid://shopify/ProductVariant/" + item.variant_id,
      quantity: item.quantity,
      title: item.product_title,
      image: item.image,
      price: item.final_price / 100,
      properties: normalizeItemProperties(item)
    }));
  }

  function getCookie(name) {
    const prefix = name + "=";
    const entry = document.cookie
      .split(";")
      .map(function (value) { return value.trim(); })
      .find(function (value) { return value.indexOf(prefix) === 0; });

    return entry ? decodeURIComponent(entry.slice(prefix.length)) : "";
  }

  function getFacebookClickId() {
    const existing = getCookie("_fbc");

    if (existing) {
      return existing;
    }

    const fbclid = new URL(window.location.href).searchParams.get("fbclid");
    return fbclid ? "fb.1." + Date.now() + "." + fbclid : "";
  }

  async function pollSession(sessionKey) {
    const response = await fetch(
        config.backendBaseUrl + "/api/checkout/session/" + sessionKey,
        {
          cache: "no-store"
        }
    );
    const data = await response.json();

    if (!data.ok) {
      return { paid: false, session: null };
    }

    if (data.session.payment_status === "paid") {
      setStatus("Төлбөр баталгаажлаа. Захиалга амжилттай бүртгэгдлээ.", "success");
      submitButton.disabled = false;
      submitButton.textContent = "Төлбөр баталгаажсан";
      closeModal();
      renderSuccessModal();
      try {
        await clearCart();
      } catch (error) {
        console.warn("[qpay-checkout] cart clear failed after successful payment", error);
      }
      if (checkButton) {
        checkButton.disabled = true;
        checkButton.textContent = "Төлбөр баталгаажсан";
      }
      if (modalCheckButton) {
        modalCheckButton.disabled = true;
        modalCheckButton.textContent = "Төлбөр баталгаажсан";
      }
      return { paid: true, session: data.session };
    }

    setStatus("Төлбөр төлөгдөөгүй байна. Төлбөрөө хийгээд дахин шалгана уу.", "error");
    return { paid: false, session: data.session };
  }

  form.addEventListener("submit", async function (event) {
    event.preventDefault();
    const paymentMethod = getSelectedPaymentMethod();

    if (activeSessionKey) {
      try {
        const result = await pollSession(activeSessionKey);
        if (!result.paid) openModal();
      } catch (error) {
        setStatus("Төлбөрийн төлөв шалгаж чадсангүй. Дахин шалгана уу.", "error");
      }
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = "Үүсгэж байна...";

    try {
      const cart = await getCart();
      const formData = new FormData(form);
      const shippingPrice = Number(formData.get("shipping_price") || "0");
      const shippingTitle = formData.get("shipping_title");
      const isPickup = isPickupShippingTitle(shippingTitle);
      const phone = formData.get("phone") || "";
      const detailedAddress = formData.get("detailed_address") || "";
      const payload = {
        customer: {
          email: formData.get("email") || undefined,
          firstName: isPickup && !formData.get("first_name") ? "Pickup" : formData.get("first_name"),
          lastName: formData.get("last_name") || "",
          address1: isPickup ? PICKUP_SHIPPING_TITLE : detailedAddress,
          address2: "",
          detailedAddress: detailedAddress,
          entranceCode: formData.get("entrance_code") || "",
          city: isPickup && !formData.get("city") ? "Ulaanbaatar" : formData.get("city"),
          province: formData.get("province"),
          postalCode: "",
          countryCode: formData.get("country_code") || "MN",
          phone: phone,
          additionalPhone: formData.get("additional_phone") || "",
          manychatSubscriberId: formData.get("manychat_subscriber_id") || ""
        },
        shipping: {
          title: shippingTitle,
          price: shippingPrice
        },
        paymentMethod: paymentMethod,
        tracking: {
          fbp: getCookie("_fbp"),
          fbc: getFacebookClickId(),
          eventSourceUrl: window.location.href
        },
        items: normalizeCartItems(cart)
      };

      const response = await fetch(config.backendBaseUrl + "/api/checkout/session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (!data.ok) {
        throw new Error(data.error || "Session create failed");
      }

      const amount = data.order.totalPrice;
      activeSessionKey = data.sessionKey;

      if (paymentMethod === "cod") {
        setStatus("Захиалга бүртгэгдлээ. Бараагаа хүлээн авахдаа төлбөрөө төлөөрэй.", "success");
        form.innerHTML = '<div class="qpay-checkout__section"><h2 class="qpay-checkout__title">Захиалга бүртгэгдлээ</h2><p>Бараагаа хүлээн авахдаа төлбөрөө төлөөрэй. Бид хүргэлтийн талаар тантай холбогдоно.</p><p data-cod-order></p><a href="/">Дэлгүүр рүү буцах</a></div>';
        form.querySelector("[data-cod-order]").textContent = "Захиалга: " + (data.order.name || data.order.orderId);
        try { await clearCart(); } catch (error) { console.warn("[checkout] cart clear failed", error); }
      } else if (paymentMethod === "bank") {
        setStatus(
            "Захиалга бүртгэгдлээ. Доорх дансны мэдээллээр шилжүүлэг хийгээд утасны дугаараа гүйлгээний утганд бичнэ үү.",
            "success"
        );
        if (checkButton) {
          checkButton.hidden = true;
        }
        if (openModalButton) {
          openModalButton.hidden = true;
        }
        submitButton.textContent = "Дансны мэдээлэл харах";
        renderBankTransferModal(amount, data.order.currency);
        try {
          await clearCart();
        } catch (error) {
          console.warn("[qpay-checkout] cart clear failed after bank order creation", error);
        }
      } else {
        const invoice = data.invoice || {};
        setStatus(
            "QPay нэхэмжлэл үүслээ. Доорх QR эсвэл линкээр төлөөд энэ хуудсыг нээлттэй үлдээнэ үү. Нийт: " +
            formatMoney(amount, data.order.currency),
            "success"
        );

        if (checkButton) {
          checkButton.hidden = false;
          checkButton.disabled = false;
          checkButton.textContent = "Төлбөр шалгах";
        }

        if (openModalButton) {
          openModalButton.hidden = false;
          openModalButton.disabled = false;
        }

        submitButton.textContent = "QR дахин харах";
        renderQPayModal(invoice, amount, data.order.currency);
      }

      submitButton.disabled = false;
    } catch (error) {
      setStatus(error.message || "Алдаа гарлаа", "error");
      submitButton.disabled = false;
      setCheckoutSubmitLabel();
    }
  });

  if (checkButton) {
    checkButton.addEventListener("click", async function () {
      if (!activeSessionKey) {
        return;
      }

      checkButton.disabled = true;
      checkButton.textContent = "Шалгаж байна...";

      try {
        const result = await pollSession(activeSessionKey);

        if (!result.paid) {
          checkButton.textContent = "Төлбөр төлөгдөөгүй";
        }
      } catch (error) {
        setStatus(error.message || "Төлбөр шалгах үед алдаа гарлаа.", "error");
      } finally {
        if (checkButton.textContent !== "Төлбөр баталгаажсан") {
          checkButton.disabled = false;
          if (checkButton.textContent !== "Төлбөр төлөгдөөгүй") {
            checkButton.textContent = "Төлбөр шалгах";
          }
        }
      }
    });
  }

  if (modalCheckButton) {
    modalCheckButton.addEventListener("click", async function () {
      if (!activeSessionKey) {
        return;
      }

      modalCheckButton.disabled = true;
      modalCheckButton.textContent = "Шалгаж байна...";

      try {
        const result = await pollSession(activeSessionKey);

        if (!result.paid) {
          modalCheckButton.textContent = "Төлбөр төлөгдөөгүй";
        }
      } catch (error) {
        setStatus(error.message || "Төлбөр шалгах үед алдаа гарлаа.", "error");
      } finally {
        if (modalCheckButton.textContent !== "Төлбөр баталгаажсан") {
          modalCheckButton.disabled = false;
          if (modalCheckButton.textContent !== "Төлбөр төлөгдөөгүй") {
            modalCheckButton.textContent = "Төлбөр шалгах";
          }
        }
      }
    });
  }

  if (openModalButton) {
    openModalButton.addEventListener("click", openModal);
  }
})();
